export const apiConfig = {
  baseURL: '/api/admin/v1',
  v2BaseURL: '/api/admin/v2',
  timeout: 10000, // optional
}
